var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilIconUnfilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_2985043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.42914 8.53598C1.31714 8.53598 1.20536 8.49332 1.11983 8.40779C0.948988 8.23695 0.948988 7.96001 1.11983 7.78916L7.95664 0.952352C8.12727 0.781508 8.40443 0.781508 8.57527 0.952352C8.74611 1.1232 8.74611 1.40013 8.57527 1.57098L1.73846 8.40779C1.65314 8.4931 1.54114 8.53598 1.42914 8.53598Z",
    fill: "#888888"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.753855 11.6879C0.723449 11.6879 0.692605 11.6846 0.661761 11.678C0.425511 11.6273 0.275011 11.3947 0.325761 11.1585L1.0017 8.00782C1.05245 7.77157 1.28607 7.62151 1.52123 7.67182C1.75748 7.72257 1.90798 7.9551 1.85723 8.19135L1.18129 11.342C1.13732 11.5474 0.955761 11.6879 0.753855 11.6879Z",
    fill: "#888888"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.90375 11.0123C3.79175 11.0123 3.67997 10.9697 3.59444 10.8841C3.4236 10.7133 3.4236 10.4364 3.59444 10.2655L10.4313 3.42891C10.6019 3.25807 10.879 3.25807 11.0499 3.42891C11.2207 3.59976 11.2207 3.8767 11.0499 4.04754L4.21329 10.8841C4.12775 10.9697 4.01575 11.0123 3.90375 11.0123Z",
    fill: "#888888"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.752646 11.6877C0.550739 11.6877 0.369396 11.5472 0.325208 11.3418C0.274677 11.1056 0.424958 10.873 0.661208 10.8223L3.81186 10.1464C4.04833 10.0963 4.28086 10.2463 4.3314 10.4824C4.38193 10.7186 4.23165 10.9511 3.9954 11.0019L0.84474 11.6778C0.813896 11.6846 0.783052 11.6877 0.752646 11.6877Z",
    fill: "#888888"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.50347 5.41216C9.39147 5.41216 9.27947 5.36951 9.19416 5.28398L6.71944 2.80926C6.5486 2.63841 6.5486 2.36148 6.71944 2.19063C6.89007 2.01979 7.16744 2.01979 7.33807 2.19063L9.81279 4.66535C9.98363 4.8362 9.98363 5.11313 9.81279 5.28398C9.72747 5.36951 9.61547 5.41216 9.50347 5.41216Z",
    fill: "#888888"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.7407 4.17405C10.6287 4.17405 10.5167 4.13139 10.4312 4.04586C10.2604 3.87502 10.2604 3.59808 10.4312 3.42702C10.6747 3.18355 10.8088 2.85389 10.8088 2.49908C10.8088 2.14427 10.6747 1.81461 10.4312 1.57114C10.1875 1.32745 9.85785 1.19336 9.50304 1.19336C9.14823 1.19336 8.81857 1.32745 8.5751 1.57114C8.40448 1.74198 8.12754 1.7422 7.95626 1.57114C7.78541 1.4003 7.78541 1.12336 7.95626 0.952297C8.36488 0.543453 8.91416 0.318359 9.50304 0.318359C10.0917 0.318359 10.6412 0.543453 11.0498 0.952297C11.4587 1.36092 11.6838 1.9102 11.6838 2.49908C11.6838 3.08795 11.4587 3.63723 11.0498 4.04586C10.9647 4.13117 10.8527 4.17405 10.7407 4.17405Z",
    fill: "#888888"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIconUnfilled);
export default __webpack_public_path__ + "static/media/PencilIconUnfilled.252f930ac0df419cb6f8ab9e0756dae1.svg";
export { ForwardRef as ReactComponent };